import React from 'react';
import {UserGetSchema} from '../../../../api/DBSchema/User';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';

const pageSchema = UserGetSchema.pages.customFields;
const pageId = pageSchema.pageId;

function UserCustomFields({
    userObject,
    setUserData
}) {
    const pageData = userObject[pageId];

    const customFieldOne = pageData[pageSchema.customFieldOne];
    const customFieldTwo = pageData[pageSchema.customFieldTwo];
    
    const customFieldSchema = pageSchema.customFieldSchema;

    return (
        <EditorLayout>
            {
                customFieldOne && (
                    <SMCTextInput
                        value={customFieldOne[customFieldSchema.value]}
                        onChange={e => setUserData([pageId, pageSchema.customFieldOne, customFieldSchema.value], e.target.value)}
                        label={customFieldOne[customFieldSchema.name]}
                    />
                )
            }
            {
                customFieldTwo && (
                    <SMCTextInput
                        value={customFieldTwo[customFieldSchema.value]}
                        onChange={e => setUserData([pageId, pageSchema.customFieldTwo, customFieldSchema.value], e.target.value)}
                        label={customFieldTwo[customFieldSchema.name]}
                    />
                )
            }
        </EditorLayout>
    )
}

export default UserCustomFields;